import styled from "styled-components";
import {SlideProps} from "@FRAMEWORK/ui/types/d";
import {ReactNode, forwardRef, useRef, useState} from "react";
import {Swiper} from "swiper/react";
import SwiperCore, {Pagination} from "swiper";

interface Props extends SlideProps {
	children: ReactNode;
	perView?: number;
	spaceBetween?: number;
}

const SlideWrap = styled.div`
	position: relative;
	width: 100%;
	padding-top: 20px;
	margin-top: 20px;
	border-top: 1px solid var(--line-color);
`;

const Slider = styled(Swiper)`
	width: 1200px;
	cursor: pointer;
`;

const SlideSlideButtonWrap = styled.div`
	button {
		position: absolute;
		top: 50%;
		width: 40px;
		height: 40px;
		border: 1px solid #d0d0d0;
		border-radius: 50%;
		background-color: #fff;
		transform: translateY(-50%);

		&:after {
			position: absolute;
			top: 16px;
			display: block;
			width: 6px;
			height: 6px;
			border-top: 1px solid #848484;
			border-right: 1px solid #848484;
			font-size: 0;
			content: "";
		}
		&:hover:not(:disabled) {
			background-color: #333;
			border-color: #333;
			&:after {
				border-top: 1px solid #fff;
				border-right: 1px solid #fff;
			}
		}
		&:disabled {
			border: 1px solid #e5e5e5;
			cursor: unset;
			&::after {
				border-top: 2px solid #e5e5e5;
				border-right: 2px solid #e5e5e5;
			}
		}
	}
`;
const SlideNextbutton = styled.button`
	right: -60px;

	&:after {
		right: 17px;
		transform: rotate(45deg);
	}
`;
const SlidePrevbutton = styled.button`
	left: -60px;
	&:after {
		left: 17px;
		transform: rotate(-135deg);
	}
`;

const RecommendationSlide = forwardRef<SwiperCore, Props>(({children, perView, spaceBetween}, ref) => {
	const [index, setIndex] = useState<number>(0);

	const handlePrev = () => {
		(ref as {current: SwiperCore}).current?.slidePrev();
	};
	const handleNext = () => {
		(ref as {current: SwiperCore}).current?.slideNext();
	};

	return (
		<SlideWrap>
			<Slider
				onBeforeInit={swiper => {
					if (ref !== null) {
						(ref as {current: SwiperCore}).current = swiper;
					}
				}}
				onActiveIndexChange={swiper => {
					setIndex(swiper.activeIndex);
				}}
				slidesPerView={perView}
				spaceBetween={spaceBetween}
				modules={[Pagination]}
			>
				{children}
			</Slider>
			{(ref as {current: SwiperCore}).current?.slides.length > perView && (
				<SlideSlideButtonWrap>
					<SlidePrevbutton disabled={index === 0} onClick={handlePrev} />
					<SlideNextbutton
						disabled={index === (ref as {current: SwiperCore}).current?.slides.length - 4}
						onClick={handleNext}
					/>
				</SlideSlideButtonWrap>
			)}
		</SlideWrap>
	);
});

export default RecommendationSlide;
